module.exports = {"141028100":"吉昌镇","141028101":"屯里镇","141028102":"壶口镇","141028200":"车城乡","141028201":"文城乡","141028202":"东城乡","141028203":"柏山寺乡","141028204":"中垛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141028.json
// module id = 327
// module chunks = 0